import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { shadow3 } from '../styles/util';
import { fromThemeColors } from '../Theme';
export var StyledMenu = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbox-shadow: ", ";\n\tlist-style: none;\n\tmargin: ", ";\n\tpadding: 8px 0;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n"])), shadow3.boxShadow, function (props) {
  return props.attachRight ? '0 0 0 auto' : '0px';
}, fromThemeColors('flyoverBackground'));